"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationLogger = void 0;
const OperationTree_1 = require("./OperationTree");
const OperationDecorator_1 = require("./OperationDecorator");
class OperationLogger {
    static getTryCatchFinallyHook(_ctx) {
        throw new Error('OperationLogger.getTryCatchFinallyHook is abstract and must be implemented by derived class');
    }
    onTry(ctx) {
        return this.stageLog(ctx);
    }
    onFinally(ctx) {
        return this.stageLog(ctx);
    }
    stageLog(ctx) {
        if (!ctx.sharedContext.logs)
            ctx.sharedContext.logs = [];
        if (!ctx.logs)
            ctx.logs = [];
        const stageLogMessages = this.getOperationLogMessages(ctx);
        if (stageLogMessages)
            ctx.logs.push(...stageLogMessages);
        return () => {
            let shouldLog = ctx.decoratorArgs?.shouldLog?.(ctx);
            if (shouldLog === undefined)
                shouldLog = this.shouldLogDefault(ctx);
            if (shouldLog) {
                const fullLogMessage = (ctx.logs || [])
                    .concat(...(ctx.sharedContext.logs || []))
                    .filter((t) => t)
                    .join('. ');
                const logDetails = ctx.logMetadata || ctx.sharedContext.logMetadata
                    ? { ...ctx.sharedContext.logMetadata, ...ctx.logMetadata }
                    : undefined;
                if (ctx.error)
                    this.logError(fullLogMessage, { error: ctx.error, ...logDetails });
                else
                    this.logInfo(fullLogMessage, logDetails);
            }
            ctx.logs.length = 0;
        };
    }
    shouldLogDefault(_ctx) {
        return true;
    }
    getOperationLogMessages(ctx) {
        const res = [];
        switch (ctx.stage) {
            case 'try':
                res.push(this.getOperationTryMessage(ctx));
                break;
            case 'finally':
                res.push(this.getOperationCompletedMessage(ctx));
                if (ctx.error) {
                    const error = ctx.error;
                    res.push(...(this.getOperationErrorDetails(error, ctx) || []));
                }
                break;
            default:
                break;
        }
        return res;
    }
    getOperationTryMessage(ctx) {
        return `${this.getOperationName(ctx)} starting...`;
    }
    getOperationName(ctx, fullPath = true, separator = ' > ') {
        if (!fullPath)
            return OperationDecorator_1.OperationDecorator.getOperationName(ctx) || '(anonymous)';
        const fullOperationName = OperationTree_1.OperationTree.getOperationsStack(ctx)
            .map((op) => this.getOperationName(op, false))
            .join(separator);
        return fullOperationName;
    }
    getOperationCompletedMessage(ctx) {
        const hasError = !!ctx.error;
        const fullOperationName = this.getOperationName(ctx);
        const duration = ctx.duration;
        if (duration !== undefined)
            return `${fullOperationName} ${hasError ? 'failed' : 'succeeded'} after ${duration} ms`;
        else
            return `${fullOperationName} ${hasError ? 'failed' : 'succeeded'}`;
    }
    getOperationErrorDetails(error, ctx) {
        const errorContext = error.trackedContext;
        const logMessages = [];
        logMessages.push(this.getErrorMessage(error, ctx));
        if (errorContext == ctx && error.underlyingError) {
            logMessages.push(`Underlying error: ${this.getErrorMessage(error.underlyingError, ctx)}`);
        }
        return logMessages;
    }
    getErrorMessage(error, _ctx) {
        if (error instanceof Error) {
            const trError = error;
            const errorClass = trError?.constructor?.name;
            return `${errorClass || '[undefined]'}: ${trError.message}`;
        }
        return error?.toString?.() || 'unknown error';
    }
}
exports.OperationLogger = OperationLogger;
//# sourceMappingURL=OperationLogger.js.map